export const formatRupiah = (angka) => {
  return "Rp " + Math.floor(angka).toLocaleString("id-ID");
};

export function normHouseKey(h) {
  return "house:" + h.trim().toUpperCase();
}
export async function sget(key) {
  if (!window.storage || !window.storage.get) {
    const local = localStorage.getItem(key);
    return local ? JSON.parse(local) : null;
  }

  try {
    const r = await window.storage.get(key, true);
    return r ? JSON.parse(r.value) : null;
  } catch (e) {
    return null;
  }
}